/**
 * Purpose of this store is to store the state of the application when routing between containers
 * In order to decouple the logic from the routing libraries, we need to handle the state ourselves
 */
import store from './store';

export const onboardStore = store;
export * from './actions';
